import { render, staticRenderFns } from "./InitialPublicOfferingsProducts.vue?vue&type=template&id=65f77094&scoped=true"
import script from "./InitialPublicOfferingsProducts.vue?vue&type=script&lang=ts&setup=true"
export * from "./InitialPublicOfferingsProducts.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./InitialPublicOfferingsProducts.vue?vue&type=style&index=0&id=65f77094&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f77094",
  null
  
)

export default component.exports